import { render, staticRenderFns } from "./Oktagon.vue?vue&type=template&id=79ba7385&"
import script from "./Oktagon.vue?vue&type=script&lang=js&"
export * from "./Oktagon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports